import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SubmissionSuccess = ({ 
  trackingId, 
  estimatedApproval, 
  onClose,
  onViewStatus 
}) => {
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-2xl p-6 md:p-8 max-w-md w-full border border-border shadow-xl">
        <div className="text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-4 rounded-full bg-gradient-to-br from-success to-primary flex items-center justify-center">
            <Icon name="CheckCircle" size={40} color="#FFFFFF" />
          </div>

          <h2 className="text-xl md:text-2xl font-bold text-foreground mb-2">
            Submission Successful!
          </h2>
          
          <p className="text-sm md:text-base text-muted-foreground mb-6">
            Your cashback claim has been submitted for review
          </p>

          <div className="bg-muted/30 rounded-xl p-4 mb-6 space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-xs md:text-sm text-muted-foreground">
                Tracking ID:
              </span>
              <span className="text-sm md:text-base font-mono font-semibold text-foreground">
                {trackingId}
              </span>
            </div>
            
            <div className="h-px bg-border"></div>
            
            <div className="flex items-center justify-between">
              <span className="text-xs md:text-sm text-muted-foreground">
                Expected Approval:
              </span>
              <span className="text-sm md:text-base font-medium text-primary">
                {estimatedApproval}
              </span>
            </div>
          </div>

          <div className="space-y-3">
            <Button
              variant="default"
              iconName="Eye"
              onClick={onViewStatus}
              fullWidth
            >
              View Status
            </Button>
            
            <Button
              variant="outline"
              iconName="Plus"
              onClick={onClose}
              fullWidth
            >
              Submit Another
            </Button>
          </div>

          <div className="mt-6 p-3 bg-primary/10 rounded-lg border border-primary/20">
            <div className="flex items-start gap-2">
              <Icon name="Bell" size={16} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
              <p className="text-xs text-primary text-left">
                We'll notify you via email and push notification once your submission is reviewed
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmissionSuccess;